// Construye el hipervínculo directo a la interacción en Genesys PureCloud.
//
// Esquema correcto (confirmado por el equipo de Genesys, jun 2026):
//   https://apps.usw2.pure.cloud/directory/#/analytics/interactions/{id}/admin
// El `?tabId=...` que a veces aparece lo autogenera Genesys al abrir la pestaña,
// no hace falta enviarlo. (Antes se usaba `/engage/admin/interactions/.../admin`,
// que metía un "admin" de más y rompía la liga.)
//
// La base es configurable vía REACT_APP_GENESYS_BASE por si la org migra de
// región (p.ej. usw2 → use1).

const GENESYS_BASE =
  process.env.REACT_APP_GENESYS_BASE ||
  'https://apps.usw2.pure.cloud/directory/#/analytics/interactions';

/**
 * @param {string|null|undefined} conversationId
 * @returns {string|null} URL a la interacción, o null si no hay id
 */
export function genesysInteractionUrl(conversationId) {
  if (!conversationId) return null;
  return `${GENESYS_BASE}/${conversationId}/admin`;
}
